/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'space-directory.filters.personal.v2': 'Persönlich',
  'space-directory.filters.starred': 'Mit Stern markiert',
};
